module.exports = __webpack_public_path__ + "assets/media/client-5.665d22f4.svg";